import { gql } from "graphql-request";

const SERVER_DELETE_COMPANY_FEED = gql`
  mutation DeleteCompanyFeed($id: ID!) {
  deleteCompanyFeed(id: $id)
}
`;
export default SERVER_DELETE_COMPANY_FEED;
